module.exports = __webpack_public_path__ + "img/ubiquity.d14b53ea.webp";